import { Icon, type TIconProps } from '~/components/icon'
import type { TagVariants } from '../../types'

export function TagIcon({
  symbol,
  testID,
  variant,
}: { symbol?: TIconProps['symbol']; variant?: TagVariants; testID?: string }) {
  const renderIconSymbol = () => {
    if (variant === 'on-sale') {
      return 'rdicon-arrow-down'
    }
    return symbol
  }

  const colorMap = {
    'on-sale': 'colorLabelingTextOnsaleDefault',
    principal: 'colorLabelingTextPrincipalDefault',
    secondary: 'colorLabelingTextSecondaryDefault',
    'clube-drogasil': 'colorLabelingTextClubeDefault',
    'clube-raia': 'colorLabelingTextClubeDefault',
    assinatura: 'colorLabelingTextAssinaturaDefault',
    'medicamento-de-geladeira': 'colorLabelingTextRefrigerateDefault',
    'receita-obrigatoria': 'colorLabelingTextPrescriptionDefault',
    generico: 'colorLabelingTextGenericoDefault',
    referencia: 'colorLabelingTextReferenciaDefault',
    similar: 'colorLabelingTextSimilarDefault',
    'ganhe-stix': 'colorLabelingTextStixDefault',
    'trocar-stix': 'colorLabelingTextStixDefault',
  } as const

  return (
    <Icon
      size="tiny"
      testID={testID}
      symbol={renderIconSymbol()}
      color={variant ? colorMap[variant] : 'colorLabelingTextOnsaleDefault'}
    />
  )
}
